import React from 'react';
import ReactDOM from 'react-dom';

import css from './Modal.module.scss';

class Modal extends React.Component {
    componentDidMount() {
        document.body.style.overflow = 'hidden';
    }

    componentWillUnmount() {
        document.body.style.overflow = '';
    }

    captureEvents(event) {
        event.stopPropagation();
    }

    render() {
        return ReactDOM.createPortal(
            <div className={css.modal} onClick={this.captureEvents}>
                {this.props.children}
            </div>,
            document.getElementById('modal')
        );
    }
}

export default Modal;
